export enum DurationDataHooks {
  DURATION = 'booking-details-duration',
  ARIA_DURATION = 'booking-details-duration-aria',
}
